import { render, staticRenderFns } from "./index-submit-job-form.component.vue?vue&type=template&id=b1520734&scoped=true"
import script from "./index-submit-job-form.component.vue?vue&type=script&lang=ts"
export * from "./index-submit-job-form.component.vue?vue&type=script&lang=ts"
import style0 from "./index-submit-job-form.component.vue?vue&type=style&index=0&id=b1520734&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1520734",
  null
  
)

export default component.exports